import { DayModel } from 'app/models';

export const days: DayModel[] = [1, 2, 3, 4, 5, 6, 7];
